import React from "react";
import PnmacAnaModal from "./PlatformSpecific/Modal";
export default PnmacAnaModal;